import { WhiteBox } from "@foodpilot/foods";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { PlanningLayout } from "../ActionListLayout";
import { ListPlanningHeader } from "./Header/Header";
import { Loading } from "src/components/utils/Loading";
import { ActionsGrid } from "./ActionsGrid/ActionsGrid";
import { Box, Stack, useTheme } from "@mui/material";
import { ScoreWaterfall } from "../../ActionsPreview/ScoreWaterfall";
import { ActionsListContextProvider } from "./ActionsListContext";
import type { UseGridColumnsOptions } from "src/components/Grid/hooks/columnsExtension/useGridColumns";

export type ListPlanningProps = {
    showWaterfall?: boolean;
    gridColumnsOptions?: UseGridColumnsOptions;
    allowDelete?: boolean;
};

export const ListPlanning = (props: ListPlanningProps) => {
    const { areActionsReady, isEditMode, toggleEditMode } = useActionsContext();
    const { showWaterfall = true, gridColumnsOptions, allowDelete = true } = props;
    const theme = useTheme();

    if (areActionsReady === false) {
        return <Loading />;
    }

    return (
        <ActionsListContextProvider gridColumnsOptions={gridColumnsOptions}>
            <PlanningLayout>
                <Stack
                    direction="column"
                    spacing={theme.spacing(4)}
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        overflow: "hidden",
                    }}
                >
                    {/* Table section */}
                    <WhiteBox>
                        <Stack direction="column" spacing={0}>
                            {/* Header section with white background */}
                            <Box
                                sx={{
                                    backgroundColor: "#FFFFFF",
                                    padding: theme.spacing(3, 4),
                                    borderBottom: `1px solid ${theme.custom.grey[500]}`,
                                    borderTopLeftRadius: "16px",
                                    borderTopRightRadius: "16px",
                                }}
                            >
                                <ListPlanningHeader isEdit={isEditMode} toggleEdit={toggleEditMode} />
                            </Box>

                            {/* Table section */}
                            <Box
                                sx={{
                                    backgroundColor: "#FFFFFF",
                                    borderBottomLeftRadius: "16px",
                                    borderBottomRightRadius: "16px",
                                    overflow: "auto",
                                }}
                            >
                                <ActionsGrid allowDelete={allowDelete} />
                            </Box>
                        </Stack>
                    </WhiteBox>

                    {/* Waterfall chart section */}
                    {showWaterfall && (
                        <Box
                            sx={{
                                width: "100%",
                                maxWidth: "100%",
                                overflow: "hidden",
                            }}
                        >
                            <ScoreWaterfall />
                        </Box>
                    )}
                </Stack>
            </PlanningLayout>
        </ActionsListContextProvider>
    );
};
